import { useTheme } from '@mui/material/styles';
import {
  CheckCircleOutline,
  TimelapseOutlined,
  RestoreOutlined,
  HighlightOffOutlined,
  HelpOutline
} from '@mui/icons-material';

import { nortadaLogger } from '../logger';

import StatusElement from './statusElement';
import { Status, TOGGLE_STATUS, REPORT_STATUS, OPERATION_STATUS } from './interfaces';

interface Props {
  status: Status;
}

export const StatusMapper = ({ status }: Props) => {
  const theme = useTheme();

  switch (status.toUpperCase()) {
    case OPERATION_STATUS.SUCCESS: {
      return <StatusElement Icon={CheckCircleOutline} text="Success" color={theme.palette.success.main} />;
    }
    case OPERATION_STATUS.FAILURE: {
      return <StatusElement Icon={HighlightOffOutlined} text="Failure" color={theme.palette.error.main} />;
    }
    case OPERATION_STATUS.UNKNOWN: {
      return <StatusElement Icon={HelpOutline} text="Unknown" color={theme.customTypography.disabled.color} />;
    }
    case OPERATION_STATUS.CONFIRMED: {
      return <StatusElement Icon={CheckCircleOutline} text="Confirmed" color={theme.palette.success.main} />;
    }
    case OPERATION_STATUS.REJECTED: {
      return <StatusElement Icon={HighlightOffOutlined} text="Rejected" color={theme.palette.error.main} />;
    }
    case OPERATION_STATUS.PENDING: {
      return <StatusElement Icon={TimelapseOutlined} text="Pending" color={theme.palette.warning.main} />;
    }
    case TOGGLE_STATUS.ENABLED: {
      return <StatusElement Icon={CheckCircleOutline} text="Active" color={theme.palette.success.main} />;
    }
    case TOGGLE_STATUS.DISABLED: {
      return (
        <StatusElement Icon={HighlightOffOutlined} text="Disabled" color={theme.customTypography.disabled.color} />
      );
    }
    case REPORT_STATUS.CREATED: {
      return <StatusElement Icon={CheckCircleOutline} text="Created" color={theme.palette.success.main} />;
    }
    case REPORT_STATUS.FAILED: {
      return <StatusElement Icon={HighlightOffOutlined} text="Failed" color={theme.palette.error.main} />;
    }
    case REPORT_STATUS.PENDING: {
      return <StatusElement Icon={TimelapseOutlined} text="Pending" color={theme.palette.warning.main} />;
    }
    case REPORT_STATUS.EXPIRED: {
      return <StatusElement Icon={RestoreOutlined} text="Expired" color={theme.customTypography.disabled.color} />;
    }

    default: {
      throw nortadaLogger.critical(`${status} status is not supported`);
    }
  }
};
